﻿import React from 'react';
import {connect} from 'react-redux';

import {GuideFormBase, connectForm} from './GuideFormBase';
import Checkbox from '../../../Forms/Components/Checkbox';

import definitions from '../../../Style/LfStyleDefinitions';
import {required} from '../../../Forms/Validation/rules';

class Step8Form extends GuideFormBase {
    render() {
        const StepForm = this.stepFormWrapper;

        return (
            <StepForm heading="Har du eller funderar du på att skaffa något av följande husdjur?">
                <Checkbox
                    theme="big"
                    layout="inline"
                    type="checkbox"
                    id="pets__dog"
                    name="pets[0]"
                    displayname="Hund"
                    value="dog"
                    checked={this.props.formData.pets.indexOf('dog') > -1}
                />

                <Checkbox
                    theme="big"
                    type="checkbox"
                    id="pets__cat"
                    name="pets[1]"
                    displayname="Katt"
                    value="cat"
                    checked={this.props.formData.pets.indexOf('cat') > -1}
                />

                <Checkbox
                    theme="big"
                    type="checkbox"
                    id="pets__smallanimals"
                    name="pets[2]"
                    displayname="Smådjur"
                    value="smallanimals"
                    checked={this.props.formData.pets.indexOf('smallanimals') > -1}
                />
            </StepForm>
        );
    }
}

export default connectForm({ formClass: Step8Form, guideStep: 8 });